<section class="px-4">
  <h2 class="heading-m md:heading-l mb-4">Bookmarked Movies</h2>
  <!-- When the Movies are load display the results but if theres is no results show the @else message -->
  <!-- State of loading -->
  @if(!markedMoviesLoaded){
  <app-loader [GetContainer]="4" />

  <!-- Load the results if any are fetched -->
  }@else if (markedMovies.length != 0 && markedMoviesLoaded) {
  <article class="movies-container">
    <app-recommended *ngFor="let movie of markedMovies" [GetInfo]="movie" />
  </article>

  <!-- Warning message if the aren't found any movies -->
  }@else{
  <p class="text-[15px] text-white/50 mt-4">No movies found!</p>
  }
</section>

<section class="px-4 pb-10 ">
  <h2 class="heading-m md:heading-l my-6">Bookmarked TV Series</h2>
  <!-- When the Movies are load display the results but if theres is no results show the @else message -->
  <!-- State of loading -->
  @if(!markedSeriesLoaded){
  <app-loader [GetContainer]="5" />

  <!-- Load the results if any are fetched -->
  }@else if (markedSeries.length != 0 && markedSeriesLoaded) {
  <article class="movies-container">
    <app-recommended *ngFor="let series of markedSeries" [GetInfo]="series" />
  </article>

  <!-- Warning message if the aren't found any movies -->
  }@else{
  <p class="text-[15px] text-white/50 mt-4">No movies found!</p>
  }
</section>